import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/vercel/path0/components/layout/app-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompactGlobalSidebar"] */ "/vercel/path0/components/layout/compact-global-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary","withErrorBoundary"] */ "/vercel/path0/components/layout/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InlineLoading","LoadingTransition"] */ "/vercel/path0/components/layout/loading-transition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortalHeader"] */ "/vercel/path0/components/layout/portal-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafeComponent"] */ "/vercel/path0/components/layout/safe-component.tsx");
